<template>
  <mu-infinite-scroll
    :loading="load"
    loadingText="拼命加载中"
    class="load"
    v-if="load"
  />
  <div class="wrap goods-detail-wrap flex-column" v-else>
    <div class="menu-wrapper" ref="menuWrapper" v-if="currentIndex >= 0">
      <ul ref="menuList">
        <li
          v-for="(item, index) in menuData"
          :class="{ active: currentIndex === index }"
          class="menu-item verticalM"
          @click="selectMenu(index)"
        >
          <span class="menu-text verticallM-box">{{ item.value }}</span>
        </li>
      </ul>
    </div>
    <div class="flex-item goods-wrapper" ref="dishesWrapper" id="dishesWrapper">
      <router-view></router-view>
    </div>

    <div class="bottom-button">
      <mu-raised-button
        label="客服"
        class="small-button server"
        @click="openCustomServer"
        style="min-width: 15% !important;"
      />
      <!--  <mu-raised-button :label="1== 1 ? '已收藏' : '收藏'" class="small-button collect" :class="{active:1 === 1}" @click="addGoodFav"/> -->
      <mu-raised-button
        label="收藏"
        class="small-button collect"
        @click="addGoodFav"
        style="min-width: 15% !important;"
      />
      <mu-raised-button
        content="11"
        label="购物车"
        @click="gotoCart"
        class="small-button cart"
        style="min-width: 15% !important;"
        ><span class="number" v-if="cartGoodsNum > 0">{{
          cartGoodsNum
        }}</span></mu-raised-button
      >
      <mu-raised-button
        label="加入购物车"
        @click="joinCart"
        primary
        class="big-button add-cart"
        :disabled="btnDisabled"
        :class="{ disabledbtn: btnDisabled }"
        style="min-width: 27.5% !important;"
      />
      <mu-raised-button
        label="立即购买"
        @click="buyNow"
        primary
        class="big-button buyNow"
        :disabled="btnDisabled"
        :class="{ disabledbtn: btnDisabled }"
        style="min-width: 27.5% !important;"
      />
    </div>
    <!-- 商品选择 -->
    <mu-popup
      position="bottom"
      popupClass="custom-popup-bottom flex-column"
      :open="bottomPopup"
      @close="bottomPopup = false"
    >
      <div class="flex-item">
        <div class="goods-detail">
          <div class="close-button" @click="bottomPopup = false"></div>
          <div class="goods-img">
            <imgs
              :imagePath="
                skuImages &&
                skuImages.length &&
                skuImages[0].imagePath &&
                skuImages[0].imagePath.imagePath
              "
            ></imgs>
          </div>
          <div class="goods-desc">
            <p class="price">
              <samp>¥</samp
              >{{
                (goodsSkuMsg &&
                  goodsSkuMsg.sku &&
                  goodsSkuMsg.sku.goodsPrice) ||
                0.0
              }}
            </p>
            <p class="desc overflowT2">
              {{
                (goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.skuName) ||
                ""
              }}
            </p>
          </div>
        </div>
        <div
          class="goods-label"
          v-for="item in (goodsSkuMsg && goodsSkuMsg.fields)"
        >
          <p class="title">{{ item.fieldName }}</p>
          <div class="label-list">
            <span
              class="label"
              v-for="value in item.values"
              @click="selectSku(item.fieldId, value.valueId)"
              :class="{ active: value.isChecked == 1 }"
              >{{ value.valueName }}</span
            >
          </div>
        </div>
        <div class="goods-number">
          <p class="title">数量</p>
          <span class="add-btn" @click="changegoodsNum('reduce')"></span>
          <input v-model="goodsNum" />
          <span class="reduce-btn" @click="changegoodsNum('add')"></span>
          <samp>件</samp>
        </div>
      </div>
      <div class="bottom-button">
        <mu-raised-button
          label="确定"
          class="fullButton"
          primary
          @click="submit"
        />
      </div>
      <!--  <div class="bottom-button">
                <mu-raised-button label="加入购物车" class="add-cart" primary @click="joinCart"/>
                <mu-raised-button label="立即购买" class="buyNow" primary @click="buyNow"/>
            </div> -->
    </mu-popup>
    <!-- 确认diy属性 -->
    <mu-dialog
      :open="showDialog"
      title="DIY清单"
      dialogClass="custom-class diy-dialog"
      @close="showDialog = false"
    >
      <span class="close-btn" @click="showDialog = false"></span>
      <ul class="diy-list">
        <li
          class="ellipsis"
          v-for="(diyItem, index) in selectDIYinfo"
          :class="{ right: index % 2 != 0 }"
        >
          <label>{{ diyItem.fieldName }}：</label
          ><span>{{ diyItem.valueName }}</span>
        </li>
      </ul>
      <mu-flat-button
        slot="actions"
        primary
        @click="showDialog = false"
        label="取消"
      />
      <mu-flat-button slot="actions" primary @click="submitDIY" label="确定" />
    </mu-dialog>
    <mu-toast
      v-if="toast.toast"
      :message="toast.messageTip"
      class="custom-toast"
    />
  </div>
</template>
<script type="text/javascript">
import imgs from "@components/image/image";
import { mapActions, mapGetters } from "vuex";
import { storage } from "@common/utils/util.js";

export default {
  data() {
    return {
      // 滚动定位所需数据
      scrollY: 0,
      load: true,
      menuData: [
        {
          value: "商品",
        },
        {
          value: "详情",
        },
        {
          value: "参数",
        },
        {
          value: "评价",
        },
      ],
      bottomPopup: false,
      id: 1,
      showDialog: false,
      goodsId: "", //商品id
      storeId: "", //商品id
      skuId: "", //商品id
      CartGoodsNum: 0, //购物车商品数量
      goodsSkuMsg: "", //商品sku信息
      skuImages: [], //商品套图
      imgIndex: 0, //商品展示图和高清图
      goodsNum: 1, //商品数量

      diyId: null, //diyId
      skuIds: [], //选中的单品id
      selectDIYinfo: [], //选中的DIY信息

      settleDatas: [], //结算店铺列表
      OrderSettleMsg: {}, //订单信息
      couponAmounts: [], //选中的优惠券

      BuyOrAddCart: true, //true -buy     false -addCart
      toast: {
        toast: false,
        messageTip: "",
      },
    };
  },
  computed: {
    currentIndex() {
      return this.$route.meta.id;
    },
    ...mapGetters({
      goodData: "goodData", //产品信息
      diyGoodData: "diyGoodData", //DIY产品信息
      cartGoodsNum: "cartGoodsNum", //购物车商品数量
      customerLink: "customerLink", //客服链接
    }),
    btnDisabled() {
      if (
        this.goodsSkuMsg &&
        this.goodsSkuMsg.sku &&
        this.goodsSkuMsg.sku.goodsPrice > 0
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      // console.log(this.$refs)
      /*document.querySelectorAll('.homeWrapper')[0].addEventListener('scroll', this.onScroll)*/
      this.$refs.dishesWrapper.addEventListener("scroll", this.onScroll);
    });
  },
  watch: {
    // 对路由变化作出响应...
    $route(to, from) {
      document.getElementById("dishesWrapper").scrollTop = 0;
    },
    goodData(val) {
      this.goodsSkuMsg = this.goodData.goodsSkuMsg;
      this.goodsNum = this.goodData.goodsNum;
    },
  },
  methods: {
    ...mapActions({
      getCartGoodsNum: "getCartGoodsNum", //获取购物车商品数量
      getGoodsSkuMsg: "getGoodsSkuMsg", //获取商品SKU信息
      getGoodsSku: "getGoodsSku", //通过选择属性 获取 商品单品信息
      saveGoodsData: "saveGoodsData", //保存购买的商品信息
      savescrollHeight: "savescrollHeight", //存储页面滚动高度
      saveIsSelSku: "saveIsSelSku", //属性选择弹框

      addGoodsFav: "addGoodsFav", //商品添加收藏

      addMemCart: "addMemCart", //加入购物车
      getOrderSettleMsg: "getOrderSettleMsg", //直接购买
      saveSelectSku: "saveSelectSku",

      getOrderSettleMsgForDiy: "getOrderSettleMsgForDiy", //直接购买-DIY商品
      addMemCartForDiy: "addMemCartForDiy", //加入DIY商品到购物车
      getCustomerLink: "getCustomerLink", //获取客服链接
    }),
    onScroll() {
      /*this.scrolled = document.querySelectorAll('.homeWrapper')[0].scrollTop;*/
      let scrolled = this.$refs.dishesWrapper.scrollTop;
      this.savescrollHeight({
        scrollHeight: scrolled,
      });
    },
    //保存要购买的商品的信息
    saveGoodForBuy() {
      let _this = this;
      this.saveGoodsData({
        goodsSkuMsg: _this.goodsSkuMsg,
        goodsNum: _this.goodsNum,
      });
    },
    //13.9.获取购物车商品数量
    getCartNum() {
      this.getCartGoodsNum([]).then((res) => {
        this.CartGoodsNum = res;
      });
    },
    //上方菜单
    selectMenu(index) {
      if (index == this.currentIndex) {
        return;
      }
      switch (index) {
        case 0:
          this.$router.push({
            path:
              "/main/goodsDetail?goodsId=" +
              this.goodsId +
              "&storeId=" +
              (this.storeId || "") +
              "&skuId=" +
              this.skuId,
          });
          break;
        case 1:
          this.$router.push({
            path:
              "/main/goodsDetail/detail?goodsId=" +
              this.goodsId +
              "&storeId=" +
              (this.storeId || "") +
              "&skuId=" +
              this.skuId,
          });
          break;
        case 2:
          this.$router.push({
            path:
              "/main/goodsDetail/parameter?goodsId=" +
              this.goodsId +
              "&storeId=" +
              (this.storeId || "") +
              "&skuId=" +
              this.skuId,
          });
          break;
        case 3:
          this.$router.push({
            path:
              "/main/goodsDetail/evaluate?goodsId=" +
              this.goodsId +
              "&storeId=" +
              (this.storeId || "") +
              "&skuId=" +
              this.skuId,
          });
          break;
      }
    },
    //18.2.获取商品SKU信息
    getSkuMsg() {
      if (this.goodsSkuMsg) {
        this.goodsSkuMsg.fields.forEach((field) => {
          field.values.forEach((item, index) => {
            if (item.isChecked == 1 && item.isImage == 1) {
              this.skuImages = item.showImages;
              this.imgIndex = index;
            }
          });
        });
        this.load = false;
      } else {
        this.getGoodsSkuMsg([this.goodsId, this.skuId || 0]).then((res) => {
          this.goodsSkuMsg = res;
          this.goodsSkuMsg.fields.forEach((field) => {
            field.values.forEach((item, index) => {
              if (item.isChecked == 1 && item.isImage == 1) {
                this.skuImages = item.showImages;
                this.imgIndex = index;
              }
            });
          });
          //如果storeid不存在
          this.storeId = this.goodsSkuMsg.sku.storeId;
          this.saveGoodForBuy(); //将需要购买的商品信息存储
          this.load = false;

          this.getCustomerLink(this.goodsSkuMsg.sku.storeId);
        });
      }
    },
    //选择商品属性
    selectSku(fieldId, valueId) {
      this.saveSelectSku({
        fieldId: fieldId,
        valueId: valueId,
      });
      //获取商品单品信息
      let values = [];
      this.goodData.goodsSkuMsg.fields.forEach((field) => {
        field.values.forEach((item) => {
          if (item.isChecked == 1) {
            if (item.isImage == 1) {
              this.skuImages = item.showImages;
            }
            let value = {
              fieldId: item.fieldId,
              valueId: item.valueId,
            };
            values.push(value);
          }
        });
      });
      this.getGoodsSku([this.goodsId, values]).then((res) => {});
    },
    //商品加减
    changegoodsNum(action) {
      if (action == "add") {
        this.goodsNum += 1;
      } else if (action == "reduce") {
        if (this.goodsNum == 1) return;
        this.goodsNum -= 1;
      }
      this.saveGoodForBuy(); //将需要购买的商品信息存储
    },
    //打开QQ聊天
    openCustomServer() {
      let tel = 4008322777;
      /*window.location.href = 'tel://' + tel;*/
      window.location.href = this.customerLink;
      // let qq ='4008322777';
      // window.location.href = 'http://wpa.qq.com/msgrd?v=3&uin='+ qq +'&site=qq&menu=yes';
    },
    //商品加入收藏
    addGoodFav() {
      this.addGoodsFav(this.goodsId)
        .then((res) => {
          if (res.success) {
            this.toast.toast = true;
            this.toast.messageTip = "收藏成功";
            setTimeout(() => {
              this.toast.toast = false;
            }, 1500);
            //this.collectShow = true;
            //this.collectCondition = "收藏成功";
          } else {
            this.toast.toast = true;
            this.toast.messageTip = "收藏失败";
            setTimeout(() => {
              this.toast.toast = false;
            }, 1500);
          }
        })
        .catch((error) => {
          //alert(error);
        });
    },
    // 立即购买
    buyNow() {
      this.BuyOrAddCart = true;
      if (this.currentIndex >= 0) {
        this.bottomPopup = true;
        //this.saveIsSelSku({isSelSku:true });
        this.goodsSkuMsg = this.goodData.goodsSkuMsg;
        this.goodsNum = this.goodData.goodsNum;
      } else {
        this.showDialog = true;
        this.selectDIYinfo = this.diyGoodData.selectDIYinfo; //选中的DIY配件信息
        this.diyId = this.diyGoodData.diyId;
        this.skuIds = this.diyGoodData.skuIds;
        this.goodsNum = this.diyGoodData.goodsNum;
      }
    },
    // 加入购物车
    joinCart() {
      this.BuyOrAddCart = false;
      if (this.currentIndex >= 0) {
        this.bottomPopup = true;
        // this.saveIsSelSku({isSelSku:true });
        this.goodsSkuMsg = this.goodData.goodsSkuMsg;
        this.goodsNum = this.goodData.goodsNum;
      } else {
        this.showDialog = true;
        this.selectDIYinfo = this.diyGoodData.selectDIYinfo; //选中的DIY配件信息
        this.diyId = this.diyGoodData.diyId;
        this.skuIds = this.diyGoodData.skuIds;
        this.goodsNum = this.diyGoodData.goodsNum;
      }
    },
    addCart() {
      this.addMemCart([this.goodsId, this.goodsSkuMsg.sku.skuId, this.goodsNum])
        .then((res) => {
          if (res) {
            this.bottomPopup = false;
            this.getCartNum();
            this.toast.toast = true;
            this.toast.messageTip = "加入购物车成功";
            setTimeout(() => {
              this.toast.toast = false;
            }, 1500);
          }
        })
        .catch((err) => {
          this.toast.toast = true;
          this.toast.messageTip = err || "请求失败，等会再试试吧~";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        });
    },
    //添加DIY商品到购物车
    addCartDiy() {
      this.addMemCartForDiy([this.diyId, this.skuIds, this.goodsNum])
        .then((res) => {
          if (res) {
            this.getCartNum();
            this.showDialog = false;
            this.toast.toast = true;
            this.toast.messageTip = "加入购物车成功";
            setTimeout(() => {
              this.toast.toast = false;
            }, 1500);
          }
        })
        .catch((err) => {
          this.toast.toast = true;
          this.toast.messageTip = err || "请求失败，等会再试试吧~";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        });
    },
    getOrderSettle() {
      this.getOrderSettleMsg([
        this.goodsId,
        this.goodsSkuMsg.sku.skuId,
        this.goodsNum,
      ])
        .then((res) => {
          this.initSettleDatas(res); // 初始化店铺结算信息
          this.$router.push({
            path: "/main/firmorder",
          });
        })
        .catch((err) => {
          this.toast.toast = true;
          this.toast.messageTip = err || "请求失败，等会再试试吧~";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        });
    },
    //直接购买DIY商品
    getOrderSettleMsgDIY() {
      this.getOrderSettleMsgForDiy([this.diyId, this.skuIds, this.goodsNum])
        .then((res) => {
          this.initSettleDatas(res); // 初始化店铺结算信息
          this.$router.push({
            path: "/main/firmorder",
          });
        })
        .catch((err) => {
          this.toast.toast = true;
          this.toast.messageTip = err || "请求失败，等会再试试吧~";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        });
    },
    // 初始化店铺结算信息
    initSettleDatas(OrderSettleMsg) {
      let _this = this;
      let settleDatas = [];
      let couponAmounts = [];
      let redpacketAmounts = []; //console.log(this.OrderSettleMsg.storeOrderSettleMsgs)
      OrderSettleMsg.storeOrderSettleMsgs.forEach(function (item) {
        if (item.couponMsgs == null || item.couponMsgs.length == 0) {
          item.couponMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.couponMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用优惠券",
            couponAmount: 0,
          });
        }
        if (item.redpacketMsgs == null || item.redpacketMsgs.length == 0) {
          item.redpacketMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.redpacketMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用红包",
            couponAmount: 0,
          });
        }
        // 记录结算数据  店铺id 商品id  优惠券默认为0  红包默认0  备注默认为空
        let instSkuIds = [];
        item.settleGoodsMsg.cartGoodses.forEach(function (sub) {
          //每个店铺下的商品实例id
          instSkuIds.push(sub.instSkuId);
        });

        settleDatas.push({
          storeId: item.settleGoodsMsg.storeId,
          instSkuIds: instSkuIds,
          couponInstId: "0",
          redpacketInstId: "0",
          remark: "",
          dealerCode: "",
        });
        //店铺优惠券优惠金额列表
        couponAmounts.push(0);
        redpacketAmounts.push(0);
      });
      let orderData = {};
      orderData.OrderSettleMsg = OrderSettleMsg; //订单信息
      orderData.settleDatas = settleDatas; //店铺结算信息
      orderData.couponAmounts = couponAmounts; //优惠券优惠金额
      orderData.redpacketAmounts = redpacketAmounts;
      storage.local.set("orderData", orderData);
    },
    submitDIY() {
      if (this.BuyOrAddCart) {
        this.getOrderSettleMsgDIY();
      } else {
        this.addCartDiy();
      }
    },
    submit() {
      if (this.BuyOrAddCart) {
        this.getOrderSettle();
      } else {
        this.addCart();
      }
    },
    gotoCart() {
      this.$router.push({ path: "/main/cart" });
    },
  },
  components: {
    imgs,
  },
  created() {
    this.goodsId = this.$route.query.goodsId || this.$route.query.linkTarget;
    this.skuId = this.$route.query.skuId || 0;
    this.storeId = this.$route.query.storeId;
    this.getCartNum();
    this.getSkuMsg();
    this.load = false;
    this.savescrollHeight({
      scrollHeight: 0,
    });
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin.scss";
.goods-detail-wrap {
  .goods-wrapper {
    height: 100%;
  }
  .height {
    height: 12.5rem;
    background: red;
    margin-top: 10px;
  }
  .menu-wrapper {
    height: 1rem;
    background: #f5f7f9;
    > ul {
      height: 100%;
      font-size: 0;
      > li {
        display: inline-block;
        width: 25%;
        height: 100%;
        @include font-dpr(16px);
        color: #4a4a4a;
        text-align: center;
        .menu-text {
          display: inline-block;
          padding: 0 0.2rem 0.2rem 0.2rem;
          border-bottom: 0.075rem solid #f5f7f9;
        }
        &.active {
          color: #da251d;
          .menu-text {
            border-bottom-color: #d0021b;
          }
        }
      }
    }
  }
  .bottom-button {
    width: 100%;
    font-size: 0;
    .mu-raised-button {
      display: inline-block;
      border: 0px solid;
      box-shadow: none;
      border-radius: 0;
      vertical-align: top;
      min-width: auto;
      height: 1.25rem;
      .mu-raised-button-wrapper {
        position: relative;
      }
      .mu-raised-button-label {
        padding: 0;
      }
      .number {
        display: inline-block;
        padding: 0.05rem 0.125rem;
        line-height: 1;
        position: absolute;
        top: 0.05rem;
        right: 0.2rem;
        color: #fff;
        background: #e60012;
        border-radius: 1.25rem;
      }
    }
    > .small-button {
      display: inline-block;
      border-top: 1px solid #eee;
      width: 15% !important;
      @include font-dpr(11px);
      color: #636363;
      .mu-raised-button-label {
        padding-top: 0.625rem;
      }
      &.server {
        background: url(/static/images/ic_client_service_3x.png) no-repeat
          center 0.05rem;
        background-size: 0.75rem auto;
        background-color: #fff;
      }
      &.collect {
        background: url(/static/images/ic_client_collection_3x.png) no-repeat
          center 0.05rem;
        background-size: 0.75rem auto;
        background-color: #fff;
      }
      &.collect.active {
        background: url(/static/images/ic_client_collection_red_3x.png)
          no-repeat center 0.05rem;
        background-size: 0.75rem auto;
        background-color: #fff;
      }
      &.cart {
        background: url(/static/images/nav_ico_shoppingCart_3x.png) no-repeat
          center 0.05rem;
        background-size: 0.75rem auto;
        background-color: #fff;
      }
    }
    > .big-button {
      display: inline-block;
      width: 27.5%;
      @include font-dpr(16px);
      color: #fff;
      &.add-cart {
        background: #ff910e !important;
      }
      &.buyNow {
        background: #e60012;
      }
      &.add-cart.disabledbtn {
        color: rgba(0, 0, 0, 0.3);
        background: #eee !important;
      }
      &.buyNow.disabledbtn {
        color: rgba(0, 0, 0, 0.3);
        background: #eee !important;
      }
    }
  }
}
.custom-popup-bottom {
  width: 100%;
  height: 9.25rem;
  background: #fff;
  font-size: 0;
  .flex-item {
    padding: 0.2rem 0.35rem;
    .goods-detail {
      position: relative;
      padding-bottom: 0.2rem;
      border-bottom: 1px solid #dfdfdf;
      min-height: 2.4rem;
      .close-button {
        display: inline-block;
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0;
        right: 0;
        background: url(/static/images/dialog_cancel_3x.png) no-repeat center;
        background-size: cover;
        z-index: 5;
      }
      .goods-img {
        display: inline-block;
        width: 2.1rem;
      }
      .goods-desc {
        position: absolute;
        top: 0;
        right: 0;
        left: 2.575rem;
        @include font-dpr(14px);
        .price {
          padding: 0.2rem 0;
          @include font-dpr(20px);
          color: #e60012;
          > samp {
            @include font-dpr(13px);
            padding-right: 0.125rem;
          }
        }
        .desc {
          color: #444444;
          line-height: 1.4;
        }
      }
    }
    .title {
      padding: 0.1rem 0 0.25rem 0;
      @include font-dpr(14px);
      color: #666666;
    }
    .goods-label {
      padding: 0.15rem 0;
      border-bottom: 1px solid #dfdfdf;
      .label-list {
        .label {
          @include font-dpr(14px);
          display: inline-block;
          line-height: 1;
          margin: 0 0.225rem 0.15rem 0;
          padding: 0.175rem 0.3rem;
          border: 1px solid #b9b9b9;
          color: #444444;
          border-radius: 0.1rem;
          &.active {
            border-color: #d0021b;
          }
        }
      }
    }
    .goods-number {
      padding: 0.225rem 0;
      > input,
      > span {
        display: inline-block;
        height: 0.875rem;
        border: 1px solid #cfcfcf;
        border-radius: 0.1rem;
        vertical-align: middle;
      }
      > span {
        width: 0.875rem;
        &.add-btn {
          background: url(/static/images/detail_product_delete_3x.png) no-repeat
            center;
          background-size: 0.35rem auto;
        }
        &.reduce-btn {
          background: url(/static/images/detail_product_add_3x.png) no-repeat
            center;
          background-size: 0.35rem auto;
        }
      }
      > input {
        width: 1.75rem;
        margin: 0 6px;
        text-align: center;
        @include font-dpr(16px);
        color: #000000;
      }
      > samp {
        display: inline-block;
        margin-left: 0.4rem;
        @include font-dpr(14px);
        color: #666666;
        vertical-align: middle;
      }
    }
  }
  .mu-raised-button {
    display: inline-block;
    width: 50%;
    border: 0px solid;
    box-shadow: none;
    border-radius: 0;
    vertical-align: top;
    min-width: auto;
    height: 1.25rem;
    color: #fff;
    @include font-dpr(16px);
    &.add-cart {
      background: #ff910e !important;
    }
    &.buyNow {
      background: #e60012;
    }
    &.fullButton {
      width: 100%;
      background-image: linear-gradient(-90deg, #ff4901 0%, #ff7701 100%);
    }
  }
}
.diy-dialog {
  position: relative;
  .close-btn {
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
    display: inline-block;
    width: 0.3rem;
    height: 0.3rem;
    background: url(/static/images/dialog_cancel_3x.png) no-repeat center;
    background-size: cover;
  }
  .diy-list {
    font-size: 0;
    > li {
      display: inline-block;
      width: 50%;
      margin-bottom: 0.25rem;
      @include font-dpr(14px);
      color: #e60012;
      > label {
        color: #999999;
      }
      &.right {
        text-align: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// goodsDetail.vue?229ace6a